<template>
  <!-- 编辑修改乘机人 修改出行人-->
  <div>
    <van-popup
      v-model="isShow"
      :close-on-click-overlay="false"
      :close-on-popstate="true"
      :get-container="getContainer"
      :lock-scroll="true"
      class="full-height full-width"
      lazy-render
      position="right"
    >
      <div class="full-height">
        <ld-header @click-left="toggle">
          {{ $t('C184','修改出行人') }}
        </ld-header>
        <van-cell-group>
          <van-field
            v-model="psgTypeName"
            :label="$t('C114','乘客类型')"
            :readonly="true"
            input-align="left"
            is-link
            @click="showPsgType = !showPsgType"
          />

          <van-action-sheet
            v-model="showPsgType"
            :actions="PSG_TYPE"
            @select="psgTypeSelect"
          />

          <van-field
            v-model="psgInfo.surname"
            :readonly="userInfo.vipCorp.tripType!=2"
            input-align="left"
            label="姓"
            placeholder="姓"
          />
          <van-field
            v-model="psgInfo.name"
            :readonly="userInfo.vipCorp.tripType!=2"
            input-align="left"
            label="名"
            placeholder="名"
          />
          <van-field
            v-model="psgInfo.cardName"
            :label="$t('D003','证件类型')"
            :readonly="true"
            input-align="left"
            is-link
            @click="showCardType = !showCardType"
          />
          <van-action-sheet
            v-model="showCardType"
            :actions="CARD_TYPE"
            @select="cardTypeSelect"
          />

          <van-field
            v-model="psgInfo.cardNo"
            :label="$t('D008','证件号码')"
            :placeholder="$t('D008','证件号码')"
            clearable
            @input="cardNumberInput"
          />

          <van-field
            v-model="psgInfo.expiryDate"
            :label="$t('Q214','有效期')"
            :readonly="true"
            input-align="left"
            is-link
            @click="showExpiryDate = !showExpiryDate"
          />
          <van-popup
            v-model="showExpiryDate"
            :close-on-popstate="true"
            :lock-scroll="true"
            position="bottom"
          >
            <van-datetime-picker
              v-model="expiryDate"
              :max-date="maxDate"
              :min-date="nowDate"
              type="date"
              @cancel="showExpiryDate != false"
              @confirm="expiryDateSelect"
            />
          </van-popup>

          <van-field
            v-model="psgInfo.born"
            :label="$t('D013','出生日期')"
            :readonly="true"
            input-align="left"
            is-link
            @click="showDate = !showDate"
          />
          <van-popup
            v-model="showDate"
            :close-on-popstate="true"
            :lock-scroll="true"
            position="bottom"
          >
            <van-datetime-picker
              v-model="currentDate"
              :max-date="nowDate"
              :min-date="minDate"
              type="date"
              @cancel="showDate = false"
              @confirm="bornSelect"
            />
          </van-popup>

          <!-- 国籍 -->
          <van-field
            v-model="psgInfo.nationName"
            :label="$t('D017','国籍')"
            :readonly="true"
            input-align="left"
            is-link
            @click="$refs['nation'].toggle()"
          />

          <van-field
            v-model="psgInfo.placeOfIssueName"
            :readonly="true"
            input-align="left"
            is-link
            label="证件签发地"
            @click="$refs['placeOfIssue'].toggle()"
          />

          <van-field
            v-model="psgInfo.phoneNumber"
            clearable
            label="电话号码"
            max="13"
            placeholder="电话号码"
            type="number"
          />
        </van-cell-group>

        <div class="pad">
          <ld-button
            main
            size="lg"
            @click.native="comple"
          >
            {{ $t('B006','确定') }}
          </ld-button>
        </div>

        <!--  -->
        <ld-nation
          ref="nation"
          @selected="nationSelect"
        />
        <!--  -->
        <ld-nation
          ref="placeOfIssue"
          @selected="placeOfIssue"
        />
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Popup, ActionSheet, Cell, CellGroup, Field, DatetimePicker } from 'vant'
import { formatDate } from 'Utils/dateUtil'
import ldNation from 'Components/ldNation'
import ldButton from 'Common/ldButton'
import { excludeSpecial } from 'Utils/string'
import { mapGetters } from 'vuex'

/**
 * 乘机人类型
 * @desc 火车票专用
 */
const PSG_TYPE = [
  {key: '1', name: '成人'},
  {key: '2', name: '儿童'}
]

/**
 * 身份证类型
 * @desc 火车票专用
 */
const CARD_TYPE = [
  // {key:'1',name:'身份证',row: 'idNumber'},
  {key:'B',name:'护照',row: 'passport', periodRow: 'passportPeriod'},
  // {key:'J',name:'军人证', row: 'otherNumber', periodRow: 'otherPeriod' },
  // {key:'H',name:'回乡证', row: 'otherNumber', periodRow: 'otherPeriod' },
  // {key:'T',name:'台胞证', row: 'otherNumber', periodRow: 'otherPeriod' },
  // {key:'HKB',name:'户口簿', row: 'otherNumber', periodRow: 'otherPeriod' },
  // {key:'C',name:'出生证明', row: 'otherNumber', periodRow: 'otherPeriod' },
  // {key:'W',name:'外国人永久居留身份证', row: 'otherNumber', periodRow: 'otherPeriod' },
  // {key:'G',name:'港澳台居民居住证', row: 'otherNumber', periodRow: 'otherPeriod' },
  // {key:'3',name:'其它', row: 'otherNumber', periodRow: 'otherPeriod' },
]

export default {
  name: 'LdEditPsg',
  components: {
    [Popup.name]: Popup,
    [ActionSheet.name]: ActionSheet,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [DatetimePicker.name]: DatetimePicker,
    ldButton,
    ldNation
  },
  props: {
    traver:{
      type: Object,
      default() {
        return {}
      }
    },
    element:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      isShow: false,
      showPsgType: false,
      showCardType: false,
      showDate: false,
      showExpiryDate: false,
      psgTypeName: '',
      expiryDate: new Date(),
      currentDate: new Date(),
      minDate: new Date('1940-01-01'),
      nowDate: new Date(),
      maxDate:new Date('2099-12-30'),
      PSG_TYPE,
      CARD_TYPE,
      psgInfo: {}
    }
  },
  computed: {
    ...mapGetters({
      userInfo:'userInfo'
    })
  },
  methods: {
    init(){
      if (!this.psgInfo.psgType) {
        this.psgInfo.psgType=PSG_TYPE[0].key
      }
      if (!this.psgInfo.cardType){
        this.psgInfo.cardType=PSG_TYPE[0].key
      }

      this.cardTypeSelect(CARD_TYPE.find(type => type.key == this.psgInfo.cardType))
      this.psgTypeSelect(PSG_TYPE.find(type => type.key == this.psgInfo.psgType))

      if(this.psgInfo.engName){
        this.psgInfo.surname=this.psgInfo.engName.split('/')[0]
        this.psgInfo.name=this.psgInfo.engName.split('/')[1]
      }
      if(this.psgInfo.born){
        this.currentDate = new Date(this.psgInfo.born)
      }else{
        this.currentDate = new Date()
      }
    },
    cardNumberInput (val) {
      val=excludeSpecial(val)
      this.psgInfo.cardNumber=val
    },
    /**
         * 乘机人选择回调
         */
    placeOfIssue(city){
      this.psgInfo.placeOfIssueName=city.cName
      this.psgInfo.placeOfIssue = city.by3
    },
    psgTypeSelect(item) {
      this.showPsgType = false
      this.psgInfo.psgType = item.key
      this.psgTypeName = item.name
    },
    /**
     * 证件类型选择回调
     */
    cardTypeSelect(item) {
      this.showCardType = false
      this.psgInfo.cardNumber = ''
      this.psgInfo.cardName = item.name
      this.psgInfo.cardType = item.key
      this.echoCardType()
    },
    /**
     * 出生日期选择回调
     */
    bornSelect(item) {
      this.showDate = false
      this.psgInfo.born = formatDate(item).date
    },
    /**
     * 有效期选择回调
     */
    expiryDateSelect(item) {
      this.showExpiryDate = false
      this.psgInfo.expiryDate = formatDate(item).date
      this.psgInfo.passportPeriod = formatDate(item).date
    },
    /**
     * 国籍选择回调
     */
    nationSelect(city) {
      this.psgInfo.nationName = city.cName
      this.psgInfo.nation = city.by3
      this.psgInfo.nationHx= city.by3
    },
    /**
     * 新增的出行人
     * 回显证件类型，证件号码和证件有效期
     */
    echoCardType () {
      CARD_TYPE.forEach(type => {
        if (type.key == this.psgInfo.cardType) {
          this.psgInfo.cardNumber = this.psgInfo[type.row]
          if (type.periodRow) {
            this.psgInfo.expiryDate = this.psgInfo[type.periodRow]
            this.expiryDate = new Date(this.psgInfo[type.periodRow])
          }
        }
      })
    },
    /**
         * 确定按钮
         * 回填乘车人信息
         */
    comple() {
      if (this.bornShow && !this.psgInfo.born) {
        this.$validErrorTips('出生日期不能为空')
        return
      }
      if (this.expiryDateShow && !this.psgInfo.expiryDate) {
        this.$validErrorTips('证件有效期不能为空')
        return
      }
      if (this.nationShow && !this.psgInfo.nationName) {
        this.$validErrorTips('国籍不能为空')
        return
      }
      //证件号码填到对应字段
      let type = CARD_TYPE.find(type => type.key == this.psgInfo.cardType)
      this.psgInfo[type.row] = this.psgInfo.cardNumber
      this.$emit('selected', this.psgInfo)
      this.toggle()
    },
    // 返回一个特定的 DOM 节点，作为挂载的父节点
    getContainer() {
      if(this.element){
        return document.querySelector(this.element)
      }
      return ''
    },
    toggle() {
      this.isShow = !this.isShow
    },

  },
  watch: {
    traver(val) {
      if(!val.placeOfIssueName){
        val.placeOfIssueName=''
      }
      this.psgInfo = JSON.parse(JSON.stringify(val))
      this.psgInfo.cardType = 'B'
      if(!this.psgInfo.placeOfIssueName){

      }

      this.init()
    },
    'psgInfo.phoneNumber': function(val) {
      this.psgInfo.phoneNumber=excludeSpecial(val)
    },
  }
}
</script>

<style lang="less" scoped>
.pad {
  padding: 20px;
}
</style>
